import React from 'react';
import {PageNavigation, RenderOnlyFor} from '@ignitesales/neuro-application';
import LandingPage from './pages/LandingPage.jsx';
import SurveyPage from './pages/SurveyPage.jsx';
import SummaryPage from './pages/SummaryPage.jsx';
import DialogueThemeContainer from "../../../../../../shared/js/core-components/DialogueThemeContainer";
import Sidebar from "./Sidebar";
import LoadingDataIcon from "../../../../../../shared/js/core-components/LoadingDataIcon";
import {useThemeSettings} from "../../../../../../shared/js/hooks/useThemeSettings.mjs";
import BasicHeader from "../../../../../../shared/js/core-components/BasicHeader";
import classnames from "classnames";
import ProgressBarLine from "../../../../../../shared/js/core-components/ProgressBarLine";
import DialoguePageContainer from "../../../../../../shared/js/core-components/DialoguePageContainer";
import DialogueProgressBar from "../../../../../../shared/js/core-components/DialogueProgressBar";

//TODO: Page container should be DialoguePageContainer that takes a page or a map of strings to pages to render based on portal config
//Each page should use a set of common messages from core folder so that same strings are used everywhere
//Products should ideally be in core and just have override options for inside the product
//Init process should grab portal configs and place them in app (similar to what is being done for colors)
//Manifest will need to list the map of pages, the color variables and their name, question types, and portal should itself know common configs (use progress bar, etc)
//TODO: use DialogueThemeContainer to make common mobile render mode
const App = () => {
    const { getSummaryThemeConfigs } = useThemeSettings();
    const { useSidebar : themeUseSidebar } = getSummaryThemeConfigs();
    const useSummarySidebar = themeUseSidebar && window.innerWidth >= 1024;

    const headerClasses = classnames('header', {
        'header--fullWidth': !useSummarySidebar
    });

    return <DialogueThemeContainer useSocialHeader={!useSummarySidebar}>
        <BasicHeader className={headerClasses} />
        <DialoguePageContainer
            LandingPage={LandingPage}
            SurveyPage={SurveyPage}
            SummaryPage={SummaryPage}
            DetailsPage={SummaryPage}
        />
        <RenderOnlyFor forSurveyPage={true}>
            <Sidebar />
            <PageNavigation />
            <DialogueProgressBar ProgressBarComponent={ProgressBarLine} />
        </RenderOnlyFor>
        <RenderOnlyFor forSummaryPage={true} forDetailsPage={true}>
            { useSummarySidebar && <Sidebar isProductsPage={true} /> }
        </RenderOnlyFor>
        <LoadingDataIcon />
    </DialogueThemeContainer>;
};

export default App;
